import Submit from "./Submit";

export default Submit;
